/**
 * tapApi.inactivateLicensingJob returns resolved data for both 2xx and 4xx (errors are
 * not thrown). The server returns JSON `true` on success and a body with `message` on
 * 400 (RemoteException / tap-server).
 *
 * @param {*} result - Return value from tapApi.inactivateLicensingJob
 * @returns {string|null} Backend error message, or null when inactivation succeeded
 */
export function getLicensingInactivateErrorMessage(result) {
  if (result === true || result === "true") {
    return null;
  }
  if (result && typeof result === "object") {
    if (typeof result.message === "string" && result.message.length > 0) {
      return result.message;
    }
    if (typeof result.error === "string" && result.error.length > 0) {
      return result.error;
    }
    if (
      result.error &&
      typeof result.error === "object" &&
      typeof result.error.message === "string"
    ) {
      return result.error.message;
    }
  }
  if (result == null) {
    return "Error inactivating licensing job.";
  }
  return "Error inactivating licensing job.";
}
